import React, { Suspense, lazy, createContext } from "react";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import axios from "axios";
import ContainerHeader from "components/ContainerHeader/index";
import IntlMessages from "util/IntlMessages";
import LoadingOverlay from "react-loading-overlay";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetAppTwoTone";
import { Cancel } from "@material-ui/icons";
import Widget from "components/Widget/index";
import {
  Box,
  Step,
  Stepper,
  StepLabel,
  Paper,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
  Slide,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { tableIcons } from "../../../constants/Icons";
import SweetAlert from "react-bootstrap-sweetalert";
import { regStatus, userSignOut } from "actions/Auth";
import html2canvas from "html2canvas";
import GenericPdfDownloader from "./downloadPDF";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
import nomba from "../../../assets/images/nombaLogo.jpeg";
import monnify from "../../../assets/images/monnifyLogo.png";

import InterSwitchlogo from '../../../assets/images/interswitch_logo.svg'
const Checkout = lazy(() => import("./checkout"));

const AdmissionLetter = lazy(() => import("./letter"));

window.html2canvas = html2canvas;

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const DashboardContext = createContext();
const useStyles = makeStyles((theme) => ({
  root: {
    width: "90%",
  },
}));
const margin = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

const specialElementHandlers = {
  "#bypassme": function(element, renderer) {
    return true;
  },
};
class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: true,
      pwdDialog: false,
      status: false,
      activeStep: 0,
      IsOlevelSaved: false,
      IsBiodataSaved: false,
      RegComplete: false,
      Admitted: false,
      warning: false,
      acceptance: 0,
      IsPasswdChgd: false,
      AdmissionStatus: false,
      IsDocUpload: false,
      admissionLetterDrawer: false,
      paymentDialog: false,
      remitaResponse: null,
      paymentStatus: false,
      message: "",
      statusResponse: null,
      downloadDoc: [
        {
          fileExt: "",
          formId: 1,
          formUrl: "",
          levelIds: null,
          formName: "Provisional Admission Letter",
          departmentIds: null,
          formDescription: "View Letter showing Provisional Admission Details",
        },
      ],
      applicantData: [],
    };
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  getSteps = () => {
    return [
      "Biodata",
      "O-level",
      "Documents",
      "Referee Page",
      "Registration Completed",
      "Admitted",
    ];
    // return [
    //   "Biodata",
    //   "O-level",
    //   "Documents",
    //   // "Referee Page",
    //   "Registration Completed",
    //   "Under Review",
    //   "Review Completed",
    // ];
  };

  async componentDidMount() {
    try {
      this.loadContent();
      this.status();
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  }

  onCancelWarning = () => {
    this.setState({
      warning: false,
    });
  };

  closePayment = (val) => {
    this.setState({
      paymentDialog: val,
    });
  };

  /* #region  Download function for pdf */
  download = (rowData) => {
    try {
      axios({
        url: rowData.formUrl,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        NotificationManager.success("Download will begin shortly!");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${rowData.formName}.${rowData.fileExt}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      NotificationManager.error("An error occurred1!");
      // console.log("error", error);
    }
  };
  /* #endregion */

  handleRequestClose = () => {
    this.setState({ pwdDialog: false });
    this.props.history.push("/applicant/changepassword");
  };

status = async () => {
  this.setState({ loader: true });
  
  try {
    const { token } = this.props.authUser;
    const urlParams = new URLSearchParams(window.location.search);
    const nombaReference = urlParams.get("orderId");
    const monnifyReference = urlParams.get("paymentReference");
    
    // Determine which payment gateway to use
    let response;
    let paymentGateway;
    
    if (monnifyReference) {
      // Check Monnify payment
      paymentGateway = "Monnify";
      response = await fetchJSON(
        `api/CheckPayeePaymentMonnify?paymentReference=${monnifyReference}`,
        null,
        "GET",
        token
      );
    } else if (nombaReference) {
      // Check Nomba payment
      paymentGateway = "Nomba";
      response = await fetchJSON(
        `api/CheckPayeePaymentNomba?transactionReference=${nombaReference}`,
        null,
        "GET",
        token
      );
    } else {
      // No payment reference found
      this.setState({
        loader: false,
        transactionStatus: "failure",
        paymentStatus: false,
        message: "Missing payment reference.",
        statusResponse: null,
      });
      return;
    }
    
    // Handle response
    if (response.Status === "Ok") {
      this.setState({
        transactionStatus: "success",
        paymentStatus: true,
        message: "Payment successful! Thank you.",
        statusResponse: response?.Data,
        paymentGateway,
      });
    } else {
      this.setState({
        transactionStatus: "failure",
        paymentStatus: true,
        message: response.Message || "Payment failed or not found.",
        statusResponse: null,
        paymentGateway,
      });
    }
  } catch (error) {
    console.error("Payment status check failed:", error);
    this.setState({
      transactionStatus: "failure",
      paymentStatus: false,
      message: "An error occurred while checking payment status.",
      statusResponse: null,
    });
  } finally {
    this.setState({ loader: false });
  }
};

closePaymentStatus = (val) => {
  this.setState(
    {
      paymentStatus: val,
    },
    () => {
      // Reload the page and navigate to the desired route
      window.location.href = "/applicant/dashboard";
    }
  );
};


  /* #region run on load of page and get necessary documents for download for applicants */
  loadContent = async () => {
    try {
      const { token, ApplicantID } = this.props.authUser;
      const response = await fetchJSON(
        `api/Applicants/GetApplicantById?ApplicantID=${ApplicantID}`,
        null,
        "GET",
        token
      );
      // console.log(response, "OTUYNV IIVERUIVEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE");
      const admissionDocs = await fetchJSON(
        `api/listofforms?type=${2}`,
        null,
        "GET",
        token
      );
      // console.log(response)
      //
      if (response.Status === "Ok") {
        let docs;
        const {
          IsOlevelSaved,
          IsBiodataSaved,
          RegComplete,
          IsPasswdChgd,
          AdmissionStatus,
          IsUploadDocument,
          AdmissionLevel,
        } = response.Data;
        if (admissionDocs.Data) {
          docs = [...this.state.downloadDoc, ...admissionDocs.Data];
        } else {
          docs = [...this.state.downloadDoc];
        }
        this.setState({
          loader: true,
          IsOlevelSaved: IsOlevelSaved,
          IsBiodataSaved: IsBiodataSaved,
          RegComplete: RegComplete,
          IsPasswdChgd: IsPasswdChgd,
          IsDocUpload: IsUploadDocument,
          AdmissionStatus: AdmissionStatus,
          Admitted: false,
          acceptance: AdmissionLevel,
          downloadDoc: docs,
          applicantData: response.Data,
        });
        if (IsPasswdChgd === false) {
          this.setState({ pwdDialog: true });
        }
      } else {
        NotificationManager.error("Unable to complete operation.");
      }
      this.setState({ loader: false });
    } catch (error) {
      "error", error;
      this.setState({ loader: false });
      NotificationManager.error("An error occurred2.");
    }
  };
  /* #endregion */

  /* #region  Get RRR and ready payment settings */
   initiateNomba = async () => {
   try {
     const {
       SessionID,
       SchoolID,
       token,
       DOB,
       FirstName,
       LastName,
       OtherName,
       Email,
       PhoneNumber,
       Gender,
       DepartmentName,
       // DOB,
       ApplicantID,
       DeptID,
       LevelID,
       JambRegNo,
       AdmModeId,
     } = this.props.authUser;

     this.setState({ loader: true });
     // PaymentCategoryId = 10 from backend
     let model = {
       SessionID: SessionID,
       SchoolID: SchoolID,
       FirstName: FirstName,
       OtherName: OtherName,
       LastName: LastName,
       DepartmentName: DepartmentName,
       Email: Email,
       PhoneNumber: PhoneNumber,
       Gender: Gender,
       // DateOfBirth: DOB,
       DeptID: DeptID,
       LevelID: LevelID,
       AdmModeId: AdmModeId,
       PayeeTypeId: 1,
       PaymentCategoryId: 10,
       PayeeId: ApplicantID,
       ApplicantID: ApplicantID,
       JambRegNo: JambRegNo,
       PayeeName: `${FirstName} ${OtherName} ${LastName}`,
       PaymentItemId: [2],
       PayeeEmail: Email,
     };

     const response = await fetchJSON(
       `api/AddPayeePaymentNomba?payType=${10}`,
       model,
       "POST",
       token
     );

     if (response.Status == "OK") {
       response.Data.token = token;
       response.Data.payerEmail = Email;
       response.Data.payerPhone = PhoneNumber;
       response.Data.payerName = model.PayeeName;
       response.Data.LevelID = LevelID;
       location.href = response?.Data?.checkOutUrl;
       this.setState({
         loader: false,
         remitaResponse: response.Data,
         paymentType: "Nomba",
         // paymentDialog: true,
       });
       NotificationManager.success("Transaction Ref generated successfully");
     } else {
       this.setState({ loader: false });
       NotificationManager.error(response.Message);
       return false;
     }
   } catch (e) {
     NotificationManager.error("An Error Occurred3");
     this.setState({ loader: false });
     e;
   }
 };

    initiateMonnify = async () => {
   try {
     const {
       SessionID,
       SchoolID,
       token,
       DOB,
       FirstName,
       LastName,
       OtherName,
       Email,
       PhoneNumber,
       Gender,
       DepartmentName,
       // DOB,
       ApplicantID,
       DeptID,
       LevelID,
       JambRegNo,
       AdmModeId,
     } = this.props.authUser;

     this.setState({ loader: true });
     // PaymentCategoryId = 10 from backend
     let model = {
       SessionID: SessionID,
       SchoolID: SchoolID,
       FirstName: FirstName,
       OtherName: OtherName,
       LastName: LastName,
       DepartmentName: DepartmentName,
       Email: Email,
       PhoneNumber: PhoneNumber,
       Gender: Gender,
       // DateOfBirth: DOB,
       DeptID: DeptID,
       LevelID: LevelID,
       AdmModeId: AdmModeId,
       PayeeTypeId: 1,
       PaymentCategoryId: 10,
       PayeeId: ApplicantID,
       ApplicantID: ApplicantID,
       JambRegNo: JambRegNo,
       PayeeName: `${FirstName} ${OtherName} ${LastName}`,
       PaymentItemId: [2],
       PayeeEmail: Email,
     };

     const response = await fetchJSON(
       `api/AddPayeePaymentMonnify?payType=${10}`,
       model,
       "POST",
       token
     );

     if (response.Status == "OK") {
       response.Data.token = token;
       response.Data.payerEmail = Email;
       response.Data.payerPhone = PhoneNumber;
       response.Data.payerName = model.PayeeName;
       response.Data.LevelID = LevelID;
       location.href = response?.Data?.checkOutUrl;
       this.setState({
         loader: false,
         remitaResponse: response.Data,
         paymentType: "Monnify",
         // paymentDialog: true,
       });
       NotificationManager.success("Transaction Ref generated successfully");
     } else {
       this.setState({ loader: false });
       NotificationManager.error(response.Message);
       return false;
     }
   } catch (e) {
     NotificationManager.error("An Error Occurred3");
     this.setState({ loader: false });
     e;
   }
 };

  initiateInterSwitch = async () => {
    try {
      const {
        SessionID,
        SchoolID,
        token,
        DOB,
        FirstName,
        LastName,
        OtherName,
        Email,
        PhoneNumber,
        Gender,
        DepartmentName,
        // DOB,
        ApplicantID,
        DeptID,
        LevelID,
        JambRegNo,
        AdmModeId,
      } = this.props.authUser;
      // const { FirstName,
      //   LastName,
      //   OtherName,
      //   Email,
      //   PhoneNumber,
      //   Gender,
      //   // DOB,
      //   ApplicantID,
      //   DeptID,
      //   LevelId,JambRegNo, AdmModeId } = applicantData;
      this.setState({ loader: true });
      // PaymentCategoryId = 10 from backend
      let model = {
        SessionID: SessionID,
        SchoolID: SchoolID,
        FirstName: FirstName,
        OtherName: OtherName,
        LastName: LastName,
        DepartmentName: DepartmentName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Gender: Gender,
        // DateOfBirth: DOB,
        DeptID: DeptID,
        LevelID: LevelID,
        AdmModeId: AdmModeId,
        PayeeTypeId: 1,
        PaymentCategoryId: 10,
        PayeeId: ApplicantID,
        ApplicantID: ApplicantID,
        JambRegNo: JambRegNo,
        PayeeName: `${FirstName} ${OtherName} ${LastName}`,
        PayeeEmail: Email,
      };
     
      const response = await fetchJSON(
        `api/InitiatePayeePayment?payType=${10}`,
        model,
        "POST",
        token
      );
      if (response.Status == "OK") {
        response.Data.token = token;
        response.Data.payerEmail = Email;
        response.Data.payerPhone = PhoneNumber;
        response.Data.payerName = model.PayeeName;
        this.setState({
          loader: false,
          remitaResponse: response.Data,
          paymentDialog: true,
        });
        NotificationManager.success("Transaction Ref generated successfully");
      } else {
        this.setState({ loader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ loader: false });
      e;
    }
  };
  /* #endregion */

  //confirm reg submission=== === ===
  handleReg = async () => {
    const { token, ApplicantID } = this.props.authUser;
    const regcomplete = await fetchJSON(
      `/api/Applicants/SubmitReg?applicantId=${ApplicantID}`,
      null,
      "GET",
      token
    );

    if (regcomplete.Status === "OK") {
      this.props.regStatus(regcomplete.Data);
      this.setState((prevState) => ({ activeStep: prevState.activeStep }));
      this.setState({
        RegComplete: true,
        warning: false,
      });
    } else {
      NotificationManager.warning(regcomplete.Message);
    }
  };

  render() {
    const { Provider } = DashboardContext;
    const { match, width, authUser } = this.props;
    const {
      loader,
      IsOlevelSaved,
      IsBiodataSaved,
      RegComplete,
      IsPasswdChgd,
      IsDocUpload,
      AdmissionStatus,
      downloadDoc,
      acceptance,
      admissionLetterDrawer,
      paymentDialog,
      remitaResponse,
      paymentStatus,
      message,
      statusResponse,
    } = this.state;
    const classes = useStyles;
    const steps = this.getSteps();
    return (
      <Provider>
        <div className="app-wrapper">
          <div className="dashboard animated slideInUpTiny animation-duration-3">
            <ContainerHeader
              match={match}
              title={<IntlMessages id="sidebar.dashboard" />}
            />
            <Suspense
              fallback={
                <div
                  className="loader-view"
                  style={{
                    height:
                      width >= 1200
                        ? "calc(100vh - 265px)"
                        : "calc(100vh - 245px)",
                  }}
                >
                  <CircularProgress />
                </div>
              }
            >
              <LoadingOverlay active={loader} spinner text="Checking...">
                {acceptance == 4 ? (
                  <>
                    <Box className={classes.root}>
                      <Alert severity="success" variant="outlined">
                        Congratulations, {authUser.LastName}{" "}
                        {authUser.FirstName}!!! You admission has been finalized
                        successfully!
                      </Alert>
                      <Stepper
                        activeStep={this.state.activeStep + 6}
                        alternativeLabel
                        className=""
                      >
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </Box>

                    {/* === === === Start of Admission Documents Table === === === */}
                    <Box className={`mt-5 ${classes.root}`}>
                      <MaterialTable
                        icons={tableIcons}
                        title="My Results"
                        columns={[
                          {
                            title: "S/N",
                            render: (rowData) => rowData.tableData.id + 1,
                          },
                          {
                            title: "Document Name",
                            field: "formName",
                            render: (rowData) => {
                              return <Link to="#">{rowData.formName}</Link>;
                            },
                          },
                          {
                            title: "Description",
                            field: "formDescription",
                          },
                        ]}
                        data={downloadDoc}
                        actions={[
                          {
                            icon: () => <GetAppIcon color="action" />,
                            tooltip: "Download",
                            onClick: (event, rowData) => {
                              return (
                                (
                                  <Link
                                    to={rowData.formUrl}
                                    target="_blank"
                                    download
                                  >
                                    Download
                                  </Link>
                                ),
                                rowData.formUrl == ""
                                  ? this.setState({
                                      admissionLetterDrawer: true,
                                    })
                                  : this.download(rowData)
                              );
                            },
                          },
                        ]}
                        options={{
                          toolbar: false,
                          actionsColumnIndex: -1,

                          pageSize: 5,
                          padding: "dense",
                          headerStyle: {
                            fontSize: "13px",
                            backgroundColor: "#ccc",
                            borderBottomColor: "#111",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          },
                          paging: false,
                        }}
                      />
                      
                      
                    </Box>
                  </>
                ) : acceptance == 3 ? (
                  <>
                    <Box className={classes.root}>
                      <Alert severity="success" variant="outlined">
                        Congratulations, {authUser.LastName}{" "}
                        {authUser.FirstName}!!! You have been admitted into{" "}
                        <strong>{authUser.Applicant.DepartmentName}</strong>
                      </Alert>
                      <Stepper
                        activeStep={this.state.activeStep + 5}
                        alternativeLabel
                      >
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                      </Box>
                      <Box>
                      <Widget
                        styleName={`bg-primary text-white`}
                        className="mt-3"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="text-center">
                          {" "}
                          ...pending acceptance fee payment{" "}
                        </i>
                        <div className="d-flex flex-row justify-content-center mt-3">
                          <i className={`zmdi zmdi-card zmdi-hc-4x`} />
                        </div>
                        <div className="text-center mt-2">
                          <h3 className="jr-font-weight-medium mb-3">
                            Hello {authUser.LastName} {authUser.FirstName}
                          </h3>
                          <p className="mb-3">
                            Kindly complete acceptance fee payment to avoid
                            revocation of admission <br />
                            {/* <span
                              className="text-warning"
                              style={{ cursor: "pointer" }}
                              onClick={() => this.getRemitaDetails()}
                            >
                              click here to initialize payment
                            </span> */}
                              <div className="flex flex-row items-center justify-center gap-4 w-full">
   

                              <button
                                  id="applyForms"
                                  className="shadow-md bg-white border px-6 py-2 flex items-center justify-center min-w-[200px] rounded-lg transition-all duration-300 hover:bg-gray-50 hover:shadow-lg hover:scale-105"
                                  onClick={() => this.initiateNomba()}
                                >
                                  <img
                                    className="isw-pay-logo w-8 h-8"
                                    src={nomba}
                                    alt="nomba"
                                    width="55px"
                                  />
                                  <span className="inline-block ml-3">
                                    Pay with Nomba
                                  </span>
                                </button>
                                <span className="text-lg font-medium px-4">OR</span>
                                <button
                                  id="payMonnify"
                                  className="shadow-md bg-white border px-8 py-2 flex items-center justify-center min-w-[200px] rounded-lg transition-all duration-300 hover:bg-gray-50 hover:shadow-lg hover:scale-105"
                                  onClick={() => this.initiateMonnify()}
                                  // cursor={pointer}
                                  // disabled={true}
                                >
                                  <img
                                    className="isw-pay-logo w-8 h-8"
                                    src={InterSwitchlogo}
                                    alt="Monnify"
                                    width="30px"
                                    height="30px"
                                  />
                                  <span className="inline-block ml-3">
                                    Pay with Monnify
                                  </span>
                                </button>
                                
                              </div>
                          </p>
                        </div>
                      </Widget>
                      </Box>
                  </>
                ) : (RegComplete && acceptance < 3) ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 4}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Widget
                      styleName={`bg-primary text-white`}
                      className="mt-3"
                    >
                      <div className="d-flex flex-row justify-content-center mt-3">
                        <i className={`zmdi zmdi-timer zmdi-hc-4x`} />
                      </div>
                      <div className="text-center mt-2">
                        <h3 className="jr-font-weight-medium mb-3">
                          Hello {authUser.LastName} {authUser.FirstName}
                        </h3>
                        <p className="mb-3">
                          Your application is being reviewed!
                        </p>
                      </div>
                    </Widget>
                  </Box>
                ) : IsDocUpload ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 3}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Box className="mt-3 float-right">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          this.setState({ warning: true });
                        }}
                      >
                        Complete Registration
                      </Button>
                    </Box>
                  </Box>
                ) : IsBiodataSaved && IsOlevelSaved ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 2}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                ) : IsBiodataSaved ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 1}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                ) : (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                )}
                {/* === === === Start of Admission Status Stepper based on registration stages === === === */}
              </LoadingOverlay>
            </Suspense>
          </div>
        </div>
        <NotificationContainer />
        {/* === === === Start of Confirm Reg Dialog === === === */}
        <SweetAlert
          show={this.state.warning}
          warning
          showCancel
          confirmBtnText="Submit"
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          title="Are You Sure?"
          onConfirm={this.handleReg}
          onCancel={this.onCancelWarning}
        >
          You won't be able to change your details after you submit.
        </SweetAlert>
        {/* === === === End of Confirm Reg Dialog === === === */}
        {/* === === === Start of Change Password Dialog === === === */}
        <Dialog
          open={this.state.pwdDialog}
          onClose={(event) => {
            this.setState({ pwdDialog: true });
          }}
        >
          <DialogTitle>{"Welcome!"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You have successfully login into your account. We require you to
              change your default password.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={this.handleRequestClose} color="secondary">
                Disagree
              </Button> */}
            <Button onClick={this.handleRequestClose} color="primary">
              Proceed
            </Button>
          </DialogActions>
        </Dialog>

        {/* Admission Letter Dialog */}
        <Dialog
          fullScreen
          open={admissionLetterDrawer}
          onClose={this.toggleDrawer("admissionLetterDrawer", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#540000" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("admissionLetterDrawer", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                Admission Letter
              </Typography>
              <GenericPdfDownloader
                downloadFileName="AdmissionLetterPdf"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            <AdmissionLetter applicant={authUser} />
          </Suspense>
        </Dialog>

        {/* === === === Payment Dialog === === === */}
        <Dialog
          open={paymentDialog}
          fullWidth={true}
          TransitionComponent={Slide}
          onClose={(event) => this.closePayment(false)}
        >
          <DialogTitle
            disableTypography
            className="d-flex p-0"
            style={{ justifyContent: "flex-end" }}
          >
            <IconButton onClick={(event) => this.closePayment(false)}>
              <Cancel />
            </IconButton>
          </DialogTitle>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            <DialogContent
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Checkout
                payeeInfo={remitaResponse}
                stateChange={this.closePayment}
              />
            </DialogContent>
          </Suspense>
        </Dialog>
        {/* === === === Payment status === === === */}
          <Dialog
              open={paymentStatus}
              fullWidth={true}
              TransitionComponent={Slide}
              onClose={(event) => this.closePaymentStatus(false)}
            >
              <DialogTitle
                disableTypography
                className="d-flex p-0"
                style={{ justifyContent: "flex-end" }}
              >
                <IconButton onClick={(event) => this.closePaymentStatus(false)}>
                  <Cancel />
                </IconButton>
              </DialogTitle>
              <Suspense
                fallback={
                  <div
                    className="loader-view"
                    style={{
                      height:
                        width >= 1200
                          ? "calc(100vh - 265px)"
                          : "calc(100vh - 245px)",
                    }}
                  >
                    <CircularProgress />
                  </div>
                }
              >
                <DialogContent
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div className="text-center">
                    <div style={{ marginBottom: "20px" }}>
                      <img
                        className="isw-pay-logo w-8 h-8"
                        src={this.state.paymentGateway === "Monnify" ? monnify : nomba}
                        alt={this.state.paymentGateway === "Monnify" ? "monnify" : "nomba"}
                        width="150px"
                      />
                    </div>
                  
                    <h4>{message}</h4>
                    <h6>Transaction Reference: {statusResponse?.TransactionRef}</h6>
                    {this.state.loader && <p>Loading...</p>}
                    {this.state.transactionStatus === "success" && (
                      <div>
                        <strong>
                          <h6>What Next!</h6>
                        </strong>
                        <ul>
                          <li>
                            Your student login details have been sent to your email.
                          </li>
                          <li>
                            Your admission letter has also been sent to your email.
                          </li>
                        </ul>
                        Please check your email for further details.
                      </div>
                    )}
                  </div>
                </DialogContent>
              </Suspense>
              <button
                type="button"
                width="50px"
                className="btn btn-primary"
                onClick={(event) => this.closePaymentStatus(false)}
              >
                OK
              </button>
            </Dialog>
      </Provider>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;
  const { userMode } = auth;
  return { authUser, userMode };
};

export default connect(mapStateToProps, { regStatus, userSignOut })(Dashboard);
export { DashboardContext };
